import React from 'react';
import moduleStandardImg from '../assets/images/module_standard_hmf.png';
import { useStrapi } from '../services/useStrapi';
import { getModuleStandard } from '../services/api';

const FALLBACK = {
  titre: 'MODULE STANDARD - ADULTE',
  description: `Destinée aux particuliers, managers, référents QVCT/RH, équipes de prévention, encadrants, représentants du personnel,
ainsi qu'aux équipes associatives et publiques, cette formation s'adresse à tous ceux qui souhaitent acquérir les compétences
essentielles pour reconnaître, comprendre et accompagner des adultes en difficulté psychologique.`,
  objectifs: [
    { texte: 'Reconnaître les signes et symptômes des principaux troubles psychiques (dépression, anxiété, psychose, addictions).' },
    { texte: 'Comprendre les mécanismes et les impacts de ces principaux troubles.' },
    { texte: 'Intervenir avec calme et discernement grâce au plan d\'action AERER, même en situation difficile.' },
    { texte: 'Adopter une posture d\'écoute active et bienveillante, sans jugement.' },
    { texte: 'Orienter vers les bonnes ressources pour permettre un soutien adapté et sécurisé.' },
  ],
  sessions: [
    {
      titre: '1. Introduction & dépression',
      description: 'Comprendre la santé mentale, les facteurs de risque/protection, le rôle du secouriste et le plan d\'action. Repérer les signes et premières interventions pour la dépression.',
    },
    {
      titre: '2. Crise suicidaire & troubles anxieux',
      description: 'Appliquer l\'action 1 « Approcher, évaluer, assister » pour la dépression ; démonter les idées reçues sur le suicide ; premiers secours en cas de crise suicidaire ; présentation des troubles anxieux.',
    },
    {
      titre: '3. Attaque de panique & psychotrauma – introduction à la psychose',
      description: 'Intervenir face à une attaque de panique et après un évènement traumatique ; appliquer le plan d\'action auprès d\'une personne anxieuse (hors crise) ; repérer les signes de psychose.',
    },
    {
      titre: '4. Psychose & troubles liés aux substances',
      description: 'Secours d\'urgence en crise psychotique ; application du plan AERER hors crise ; repérage et premiers secours face aux addictions (évaluation d\'une intoxication/urgence), désamorçage des conduites agressives. Bilan.',
    },
  ],
  url_pdf: 'https://firebasestorage.googleapis.com/v0/b/help-mind-formation.firebasestorage.app/o/adulte_BD.pdf?alt=media&token=217c3466-5f86-4e56-afe2-15fd07ddd4e5',
  texte_organisation: 'Formats possibles : 2 jours consécutifs, 2 jours non consécutifs (sur 2 semaines), ou 4 demi journées (sur 1 mois max).',
};

const StandardModule = () => {
  const { data, loading } = useStrapi(getModuleStandard);
  const d = data || FALLBACK;

  return (
    <div className="container">
      <section className="section text-center">
        <img src={moduleStandardImg} alt="Module Standard" className="module-icon" />
        <h1>{d.titre}</h1>
        <p className="max-w-800">{d.description}</p>
      </section>

      <section className="section text-center">
        <h2>OBJECTIFS</h2>
        <div className="objectives-box">
          {loading ? (
            <p>Chargement…</p>
          ) : (
            <ul className="objectives-list">
              {d.objectifs.map((o, i) => (
                <li key={i}>{o.texte}</li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <section className="section text-center">
        <h2>PROGRAMME</h2>
        <p>Programme en {d.sessions.length} sessions</p>
        <div className="program-box">
          {loading ? (
            <p>Chargement…</p>
          ) : (
            <ul className="program-list">
              {d.sessions.map((s, i) => (
                <li key={i}>
                  <strong>{s.titre}</strong>
                  <br />
                  {s.description}
                </li>
              ))}
            </ul>
          )}
        </div>
        {d.url_pdf && (
          <div style={{ marginTop: '30px' }}>
            <a href={d.url_pdf} target="_blank" rel="noopener noreferrer" className="btn">
              📄 TÉLÉCHARGER LE PROGRAMME COMPLET (PDF)
            </a>
          </div>
        )}
      </section>

      <section className="section text-center">
        <h2>ORGANISATION</h2>
        <div className="organisation-box">
          <svg className="org-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <p>{d.texte_organisation}</p>
        </div>
      </section>
    </div>
  );
};

export default StandardModule;
